export type RightButton = "mic" | "send";

export function isTouchPointer(query?: (text: string) => { matches: boolean }): boolean {
  const ask = query ?? (globalThis.matchMedia as ((text: string) => { matches: boolean }) | undefined);
  if (!ask) return false;
  try {
    return ask("(pointer: coarse)").matches && ask("(hover: none)").matches;
  } catch {
    return false;
  }
}

export function rightButton(input: { has: boolean; touch: boolean }): RightButton {
  return input.has ? "send" : "mic";
}
